/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Max_Lines_HelpInputs */



/**
* | output |
* | --- |
* | "The maximum lines per event before creating a new event." |
*
* @param {Plain_Text_Import_Max_Lines_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_max_lines_help = /** @type {((inputs?: Plain_Text_Import_Max_Lines_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Max_Lines_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre maximal de lignes par evenement avant de creer un nouvel evenement.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die maximale Anzahl an Zeilen pro Ereignis, bevor ein neues Ereignis erstellt wird.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero massimo di righe per evento prima di creare un nuovo evento.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальное количество строк в одном событии перед созданием нового события.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El máximo de líneas por evento antes de crear un nuevo evento.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建新事件之前，每个事件的最大行数限制。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいイベントを作成する前のイベントあたりの最大行数。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया इवेंट बनाने से पहले प्रति इवेंट अधिकतम लाइनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O número máximo de linhas por evento antes de criar um novo evento.")
	return /** @type {LocalizedString} */ ("The maximum lines per event before creating a new event.")
});